import { render } from "./invoiceAddress.vue?vue&type=template&id=c264aa04&scoped=true"
import script from "./invoiceAddress.vue?vue&type=script&lang=js"
export * from "./invoiceAddress.vue?vue&type=script&lang=js"

import "./invoiceAddress.vue?vue&type=style&index=0&id=c264aa04&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c264aa04"]])

export default __exports__